import { useMemo } from 'react'
import { Container, Text } from '@pixi/react'
import { FeatureToggleType, isXinStarCurrency, measureTextHeight, normalRtp, useFeatureToggleStore, usePlayerStore, xinStarRtp } from '@slot-nx/core'
import { paragraphStyle, tableTitleStyle } from './textStyle'
import { ParagraphProps } from './Paragraph2'
import { t } from '@slot-nx/core'
import { TextStyle } from 'pixi.js'

const versionStyle = new TextStyle({
  fontSize: 40,
  fill: '#FFFFFF',
  wordWrap: true,
  wordWrapWidth: 960,
  breakWords: true,
  lineHeight: 45,
})

export const Paragraph10 = (props: ParagraphProps) => {
  const featureToggleStore = useFeatureToggleStore().toggleList
  const showBetHistory = !featureToggleStore.get(FeatureToggleType.disableHistoryList)
  const currency = usePlayerStore(x => x.currency)
  const isFromXinStar = useMemo(() => isXinStarCurrency(currency), [currency])
  const replaceRtp = useMemo(() => {
    return (text: string) => isFromXinStar
      ? text.replace(normalRtp, xinStarRtp)
      : text
  }, [isFromXinStar])

  const rtpRule1 = replaceRtp(t('gameRules_title8_content_1'))
  const rtpRule2 = replaceRtp(t('gameRules_title8_content_2'))

  const content = useMemo(() => {
    const disableRtpDisplay = featureToggleStore.get(FeatureToggleType.disableRTPDisplay)
    const noteY = disableRtpDisplay ? 0 : 250
    const noteText = t('gameRules_title8_content_3')
    const betHistoryTitleText = t('gameRules_betHistory_title')
    const betHistoryDescText = t('gameRules_betHistory_desc')
    const versionText = 'V1.3.5'
    const betHistoryTitleY = noteY + measureTextHeight(noteText, paragraphStyle) + 40
    const betHistoryDescY = betHistoryTitleY + measureTextHeight(betHistoryTitleText, tableTitleStyle) + 20
    // History 顯示與否都以量測高度往下疊，避免長文字撐爆下一區塊
    const versionY = showBetHistory
      ? betHistoryDescY + measureTextHeight(betHistoryDescText, paragraphStyle) + 40
      : betHistoryTitleY
    const spaceY = versionY + measureTextHeight(versionText, versionStyle) + 40
    return (
      <Container y={props.y}>
        {!disableRtpDisplay
          ? (
              <Container>
                <Text
                  text={t('gameRules_title8')}
                  anchor={[0.5, 0]}
                  x={props.width / 2}
                  style={tableTitleStyle}
                />
                <Text
                  x={60}
                  y={100}
                  text={rtpRule1}
                  style={paragraphStyle}
                />
                <Text
                  x={60}
                  text={rtpRule2}
                  style={paragraphStyle}
                  y={150}
                />
              </Container>
            )
          : null}
        <Text
          x={60}
          text={noteText}
          style={paragraphStyle}
          y={noteY}
        />
        {showBetHistory && (
          <>
            <Text text={betHistoryTitleText} anchor={[0.5, 0]} x={props.width / 2} y={betHistoryTitleY} style={tableTitleStyle} />
            <Text x={60} text={betHistoryDescText} style={paragraphStyle} y={betHistoryDescY} />
          </>
        )}
        <Text
          name="game_version"
          text={versionText}
          anchor={[0.5, 0]}
          x={props.width / 2}
          y={versionY}
          style={versionStyle}
        />
        <Text name="space" text="" y={spaceY} />
      </Container>
    )
  }
  , [featureToggleStore, showBetHistory, props.width, props.y, rtpRule1, rtpRule2])
  return content
}
